"use client"

import { SquareChevronDown } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SquareChevronDownIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SquareChevronDownIcon = component(Icon)({ as: SquareChevronDown })
